import http from './base/http';
// 餐别管理列表
export function foodTypeList(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10009',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 新增收入类别
export function addFoodType(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10009',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/foodType.js